import { createSlice } from '@reduxjs/toolkit';
import IUser from '../interfaces/IUser';
import IUserStoreState from '../interfaces/IUserStoreState';
import { AccountLogin } from '../services/UserService';
import { AppDispatchType } from './Store';
import IAppStoreState from '../interfaces/IAppStoreState';
import UnregisteredUser from '../data/UnregisteredUser';

const UserInitialState: IUserStoreState = {
  NetworkConnected: false,
  LoggedIn: false,
  Message: ''
} 

const UserSlice = createSlice({
  name: 'UserAccount',
  initialState: UserInitialState,
  reducers: {
    UpdateNetworkConnected: (state, action) => {
      state.NetworkConnected = action.payload;
      return state;
    },
    Login: (state, action) => {
      state.LoggedIn = true;
      state.User = action.payload;
      state.Message = 'Logged In'
      return state;
    },
    Logout: (state) => {
      state.LoggedIn = false;
      state.User = UnregisteredUser;
      state.Message = 'Logged Out'
      return state;
    },
    Update: (state, action) => {
      const updatedUser: IUser = action.payload
      state.User = {...state.User, ...updatedUser};
      return state;
    },
    Error: (state, action) => {
      state.Message = action.payload
      return state;
    },
    Loading: (state, action) => {
      state.Message = action.payload
      return state;
    }
  }
});

const { actions, reducer } = UserSlice;

//Actions Export
export const { UpdateNetworkConnected, Logout, Login, Update, Error, Loading } = actions;

export const LoginAsync = (user: IUser) => async (dispatch: AppDispatchType) => {
  dispatch(Loading('Logging In'));
  const loginResponse = await AccountLogin(user);
  if(loginResponse.Success){
    dispatch(Login(loginResponse.Data));
  }
  else{
    dispatch(Error(loginResponse.Message?.UserMessage));
  }
}

//Selector Export
export const SelectNetworkConnected = (state: IAppStoreState) => state.UserAccount.NetworkConnected;
export const SelectMessage = (state: IAppStoreState) => state.UserAccount.Message;
export const SelectLoginStatus = (state: IAppStoreState) => state.UserAccount.LoggedIn;
export const SelectCurrentUser = (state: IAppStoreState) => 
  state.UserAccount.User ? state.UserAccount.User : UnregisteredUser;

//Reducer Export
export default reducer;
